var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('el-button',{key:item.label,attrs:{"size":"mini"},on:{"click":function($event){return _vm.itemClick(item)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }